window.EMPLOYEE_AUDIT_CHANGE_TYPES = {
    ADD: {
        label: $filter("translate")('Add'),
        value: 'ADD',
    },
    UPDATE: {
        label: $filter("translate")('Update'),
        value: 'UPDATE',
    },
    DELETE: {
        label: $filter("translate")('Delete'),
        value: 'DELETE',
    }
};

window.EMPLOYEE_AUDIT_ACTOR_TYPES = {
    SYSTEM: {
        label: $filter("translate")('System'),
        value: 'SYSTEM',
    },
    PAYROLL: {
        label: $filter("translate")('Payroll'),
        value: 'PAYROLL',
    },
    USER: {
        label: $filter("translate")('USER'),
        value: 'USER',
    },
    POS: {
        label: $filter("translate")('POS'),
        value: 'POS',
    },
};

window.AMOUNT_DEPOSIT_TYPES_MAP = {
    ENTIRE: 'Entire',
    FIXED: 'Fixed',
    PARTIAL: 'Partial'
};

window.AMOUNT_DEPOSIT_TYPES = {
    ENTIRE: 'ENTIRE',
    FIXED: 'FIXED',
    PARTIAL: 'PARTIAL'
};

window.EMPLOYEE_AUDIT_SORT_FIELDS = {
    first_name: {
        label: $filter("translate")('First Name'),
        value: 'first_name',
    },
    last_name: {
        label: $filter("translate")('Last Name'),
        value: 'last_name',
    },
    changed_type: {
        label: $filter("translate")('Change Type'),
        value: 'changed_type',
    },
    changed_by: {
        label: $filter("translate")('Changed By'),
        value: 'changed_by',
    },
    action: {
        label: $filter("translate")('Action'),
        value: 'action',
    },
    transaction_datetime: {
        label: $filter("translate")('Last Updated'),
        value: 'transaction_datetime',
    }
};

window.EMPLOYEE_AUDIT_STATUS = {
    EFFECTIVE: {
        label: $filter("translate")('Effective'),
        value: 'EFFECTIVE',
    },
    SCHEDULED: {
        label: $filter("translate")('Scheduled'),
        value: 'SCHEDULED',
    }
};

window.EMPLOYEE_AUDIT_FIELDS = [
    {
        label: $filter("translate")('Termination Date'),
        value: 'leave_date',
    },
    {
        label: $filter("translate")('Hire Date'),
        value: 'hire_date',
    },
    {
        label: $filter("translate")('Termination Reason'),
        value: 'termination_reason',
    },
    {
        label: $filter("translate")('Stations'),
        value: 'job_titles',
    },
    {
        label: $filter("translate")('Termination Description'),
        value: 'termination_description',
    },
    {
        label: $filter("translate")('Home Location'),
        value: 'primary_location',
    },
    {
        label: $filter("translate")('Payroll Id'),
        value: 'payroll',
    },
    {
        label: $filter("translate")('Position'),
        value: 'position',
    },
    {
        label: $filter("translate")('Email'),
        value: 'email',
    },
    {
        label: $filter("translate")('Phone Number'),
        value: 'phone',
    },
    {
        label: $filter("translate")('First Name'),
        value: 'first_name',
    },
    {
        label: $filter("translate")('Last Name'),
        value: 'last_name',
    },
    {
        label: $filter("translate")('Full Address'),
        value: 'full_address',
    },
    {
        label: $filter("translate")('Bank Name'),
        value: 'bank_name',
    },
    {
        label: $filter("translate")('Pay Type'),
        value: 'pay_type_type',
    },
    {
        label: $filter("translate")('Pay Type Effective Date'),
        value: 'pay_type_start_date',
    },
    {
        label: $filter("translate")('Pay Rate'),
        value: 'pay_rate',
    },
    {
        label: $filter("translate")('Pay Rate Code'),
        value: 'pay_rate_code',
    },
    {
        label: $filter("translate")('Pay Rate Effective Date'),
        value: 'pay_rate_start_date',
    },
    {
        label: $filter("translate")('Annual Rate'),
        value: 'annual_rate_value',
    },
    {
        label: $filter("translate")('Annual Rate Effective Date'),
        value: 'annual_rate_start_date',
    },
    {
        label: $filter("translate")('Contracted Hours'),
        value: 'max_weekly_hours_value',
    },
    {
        label: $filter("translate")('Contracted Hours Effective Date'),
        value: 'max_weekly_hours_start_date',
    },
    {
        label: $filter("translate")('User Activated'),
        value: 'user_activated',
    },
    {
        label: $filter("translate")('User Deactivated'),
        value: 'user_deactivated',
    },
    {
        label: $filter("translate")('Ethnicity'),
        value: 'equal_opportunity_information_ethnicity',
    },
    {
        label: $filter("translate")('Specific Ethnicity'),
        value: 'equal_opportunity_information_specific_ethnicity',
    },
    {
        label: $filter("translate")('Other Ethnicity'),
        value: 'equal_opportunity_information_other_ethnicity',
    },
    {
        label: $filter("translate")('Disability Status'),
        value: 'equal_opportunity_information_disability_status',
    },
    {
        label: $filter("translate")('Gender Identity'),
        value: 'equal_opportunity_information_gender_identity',
    },
    {
        label: $filter("translate")('Other Gender Identity'),
        value: 'equal_opportunity_information_other_gender_identity',
    },
    {
        label: $filter("translate")('Sexual Orientation'),
        value: 'equal_opportunity_information_sexual_orientation',
    },
    {
        label: $filter("translate")('Other Sexual Orientation'),
        value: 'equal_opportunity_information_other_sexual_orientation',
    },
    {
        label: $filter("translate")('Religious Belief'),
        value: 'equal_opportunity_information_religious_belief',
    },
    {
        label: $filter("translate")('Other Religious Belief'),
        value: 'equal_opportunity_information_other_religious_belief',
    },
    {
        label: $filter("translate")('Flexible Working Arrangements'),
        value: 'equal_opportunity_information_flexible_working_arrangements',
    },
    {
        label: $filter("translate")('Other Flexible Working Arrangements'),
        value: 'equal_opportunity_information_other_flexible_working_arrangements',
    },
    {
        label: $filter("translate")('Caring Responsibilities'),
        value: 'equal_opportunity_information_caring_responsibilities',
    },
    {
        label: $filter("translate")('Type of Caring Responsibilities'),
        value: 'equal_opportunity_information_type_of_caring_responsibilities',
    },
    {
        label: $filter("translate")('First Language'),
        value: 'personal_info_additional_info_first_language',
    },
    {
        label: $filter("translate")('Pronoun'),
        value: 'personal_info_additional_info_pronoun',
    },
    {
        label: $filter("translate")("Cost Centers"),
        value: 'cost_centers'
    },
    {
        label: $filter("translate")("ADP Employee Type"),
        value: 'adp'
    },
    {
        label: $filter("translate")('Account Number'),
        value: 'account_number',
    },
    {
        label: $filter("translate")('Registration Number'),
        value: 'registration_number',
    },
    {
        label: $filter("translate")('TeamHub PIN'),
        value: 'teamhub_pin',
    },
    {
        label: $filter("translate")('Reports To'),
        value: 'reports_to',
    },
    {
        label: $filter("translate")('Known As'),
        value: 'known_as',
    },
    {
        label: $filter("translate")('Additional Contact Email'),
        value: 'additional_contact_email_secondary_email',
    },
    {
        label: $filter("translate")('Time Card Number'),
        value: 'badge',
    },
    {
        label: $filter("translate")('Include in Schedule'),
        value: 'schedulable',
    },
    {
        label: $filter("translate")('Lactation Break Periods Start Date'),
        value: 'lactation_break_period_start_date',
    },
    {
        label: $filter("translate")('Lactation Break Periods End Date'),
        value: 'lactation_break_period_end_date',
    },
    {
        label: $filter("translate")('Lactation Break Periods Description'),
        value: 'lactation_break_period_description',
    },
    {
        label: $filter("translate")('Middle Initial'),
        value: 'middle_name',
    },
    {
        label: $filter("translate")('Secondary Phone'),
        value: 'home_phone',
    },
    {
        label: $filter("translate")('POS ID'),
        value: 'employee_pos_id',
    },
    {
        label: $filter("translate")('Primary Position'),
        value: 'is_primary_position',
    },
    {
        label: $filter('translate')('Do Not Calculate Federal Tax'),
        value: 'federal_withholding_details_do_not_calculate_federal_tax',
    },
    {
        label: $filter('translate')('Do Not Calculate State Tax'),
        value: 'state_withholding_details_do_not_calculate_state_tax',
    },
    {
        label: $filter('translate')('Federal Tax Deductions Amount'),
        value: 'federal_withholding_details_federal_tax_additional_amount',
    },
    {
        label: $filter('translate')('Federal Tax Filing Status'),
        value: 'federal_withholding_details_federal_tax_deductions_amount',
    },
    {
        label: $filter('translate')('Federal Tax Other Income Amount'),
        value: 'federal_withholding_details_federal_tax_dependents_amount',
    },
    {
        label: $filter('translate')('Federal Tax Additional Amount'),
        value: 'federal_withholding_details_federal_tax_filing_status',
    },
    {
        label: $filter('translate')('Federal Tax Dependents Amount'),
        value: 'federal_withholding_details_federal_tax_multiple_jobs',
    },
    {
        label: $filter('translate')('Federal Tax Multiple Jobs'),
        value: 'federal_withholding_details_federal_tax_other_income_amount',
    },
    {
        label: $filter('translate')('State Extra Tax'),
        value: 'state_withholding_details_state_extra_tax',
    },
    {
        label: $filter('translate')('Number Of Exemptions'),
        value: 'state_withholding_details_number_of_exemptions',
    },
    {
        label: $filter('translate')('Flsa Overtime'),
        value: 'employment_info_additional_info_flsa_overtime',
    },
    {
        label: $filter('translate')('Business Unit'),
        value: 'employment_info_additional_info_business_unit',
    },
    {
        label: $filter('translate')('Home Department'),
        value: 'employment_info_additional_info_home_department',
    },
    {
        label: $filter('translate')('Benefits Eligibility Class'),
        value: 'employment_info_additional_info_benefits_eligibility_class',
    },
];

window.EMPLOYEE_AUDIT_TIPS_MANAGEMENT_FIELDS = [
    {
        label: $filter("translate")('Is Tipped'),
        value: 'tipped',
    },
    {
        label: $filter("translate")('Is Tipped Effective Date'),
        value: 'tipped_start_date',
    },
];

window.EMPLOYEE_AUDIT_MEAL_PLAN_PARTICIPANT_FIELDS = [
    {
        label: $filter("translate")('Meal Plan Participant'),
        value: 'is_meal_participant',
    },
];

window.EMPLOYEE_AUDIT_PRIVATE_MODE_FIELDS = [
    {
        label: $filter("translate")('Private Mode'),
        value: 'schedule_visibility',
    }
];

window.EMPLOYEE_AUDIT_MULTIPLE_BANK_ACCOUNT_FIELDS = [
    {
        label: $filter("translate")('Deposit Amount Type'),
        value: 'bank_account_details_deposit_amount_type',
    },
    {
        label: $filter("translate")('Amount'),
        value: 'bank_account_details_amount',
    },
    {
        label: $filter("translate")('Order'),
        value: 'bank_account_details_order',
    }
];

window.EMPLOYEE_AUDIT_STATIONS_EXTRA_PAY_FIELDS = [
    {
        label: $filter("translate")('Station extra pay'),
        value: 'station_extra_pay_value',
    }
];

window.EMPLOYEE_AUDIT_FIELDS_US = [
    {
        label: $filter("translate")('SSN'),
        value: 'ssn',
    },
    {
        label: $filter("translate")('Additional Cost Value'),
        value: 'additional_cost_value',
    },
    {
        label: $filter("translate")('Additional Cost Start Date'),
        value: 'additional_cost_start_date',
    },
    {
        label: $filter("translate")('Account Type'),
        value: 'account_type',
    },
    {
        label: $filter("translate")('Routing Number'),
        value: 'routing_number',
    },
    {
        label: $filter("translate")('City Marital Status'),
        value: 'city_withholding_details_city_marital_status',
    },
    {
        label: $filter("translate")('City Exempt Status'),
        value: 'city_withholding_details_city_exempt_status',
    },
    {
        label: $filter("translate")('City Number of Exceptions'),
        value: 'city_withholding_details_city_number_of_exceptions',
    },
    {
        label: $filter("translate")('City Additional Withholding Amount'),
        value: 'city_withholding_details_city_additional_withholding_amount',
    },
    {
        label: $filter("translate")('Emergency First Name'),
        value: 'emergency_contact_first_name',
    },
    {
        label: $filter("translate")('Emergency Last Name'),
        value: 'emergency_contact_last_name',
    },
    {
        label: $filter("translate")('Emergency Primary Phone Number'),
        value: 'emergency_contact_cell_phone_number',
    },
    {
        label: $filter("translate")('Emergency Secondary Phone Number'),
        value: 'emergency_contact_home_phone_number',
    },
    {
        label: $filter("translate")('Emergency Additional Phone Number'),
        value: 'emergency_contact_work_phone_number',
    },
    {
        label: $filter("translate")('Company Service Date'),
        value: 'employment_info_additional_info_company_service_date',
    },
    {
        label: $filter("translate")('Orientation Date'),
        value: 'employment_info_additional_info_orientation_date',
    },
    {
        label: $filter("translate")('Follow-up Orientation Date'),
        value: 'employment_info_additional_info_follow_up_orientation_date',
    },
    {
        label: $filter("translate")('Federal Marital Status'),
        value: 'federal_withholding_details_federal_marital_status',
    },
    {
        label: $filter("translate")('Federal Exempt Status'),
        value: 'federal_withholding_details_federal_exempt_status',
    },
    {
        label: $filter("translate")('Federal Number of Exceptions'),
        value: 'federal_withholding_details_federal_number_of_exceptions',
    },
    {
        label: $filter("translate")('Federal Extra Withholding'),
        value: 'federal_withholding_details_federal_extra_withholding',
    },
    {
        label: $filter("translate")('Federal Multiple Jobs'),
        value: 'federal_withholding_details_federal_multiple_jobs',
    },
    {
        label: $filter("translate")('Federal Qualifying Children Dollars'),
        value: 'federal_withholding_details_federal_qualifying_children_dollars',
    },
    {
        label: $filter("translate")('Federal Other Dependent Dollars'),
        value: 'federal_withholding_details_federal_other_dependent_dollars',
    },
    {
        label: $filter("translate")('Federal Total Dependent Dollars'),
        value: 'federal_withholding_details_federal_total_dependent_dollars',
    },
    {
        label: $filter("translate")('Federal Deduction Dollars'),
        value: 'federal_withholding_details_federal_deduction_dollars',
    },
    {
        label: $filter("translate")('Federal Other Income Dollars'),
        value: 'federal_withholding_details_federal_other_income_dollars',
    },
    {
        label: $filter("translate")('Personal Marital Status'),
        value: 'personal_info_additional_info_person_marital_status',
    },
    {
        label: $filter("translate")('National Origin'),
        value: 'personal_info_additional_info_national_origin',
    },
    {
        label: $filter("translate")('Military Veteran Status'),
        value: 'personal_info_additional_info_military_veteran_status',
    },
    {
        label: $filter("translate")('Veteran Type'),
        value: 'personal_info_additional_info_veteran_type',
    },
    {
        label: $filter("translate")('Disabled Veteran'),
        value: 'personal_info_additional_info_disabled_veteran',
    },
    {
        label: $filter("translate")('Student Status'),
        value: 'personal_info_additional_info_student_status',
    },
    {
        label: $filter("translate")('Student Permit Expiration date'),
        value: 'personal_info_additional_info_student_permit_exp_date',
    },
    {
        label: $filter("translate")('State Marital Status'),
        value: 'state_withholding_details_state_marital_status',
    },
    {
        label: $filter("translate")('State Exempt Status'),
        value: 'state_withholding_details_state_exempt_status',
    },
    {
        label: $filter("translate")('State Number of Exceptions'),
        value: 'state_withholding_details_state_number_of_exceptions',
    },
    {
        label: $filter("translate")('State Additional Withholding Amount'),
        value: 'state_withholding_details_state_additional_withholding_amount',
    },
];

window.EMPLOYEE_AUDIT_FIELDS_UK = [
    {
        label: $filter("translate")('NI Number'),
        value: 'ssn',
    },
    {
        label: $filter("translate")('Account Name'),
        value: 'account_name',
    },
    {
        label: $filter("translate")('Account Sort Code'),
        value: 'sort_code',
    },
    {
        label: $filter("translate")("Holiday Adjustments"),
        value: 'holiday_adjustments'
    },
    {
        label: $filter("translate")('Pension Contribution'),
        value: 'pension_value',
    },
    {
        label: $filter("translate")('Pension Contribution Effective date'),
        value: 'pension_start_date',
    },
    {
        label: $filter("translate")('NI Category'),
        value: 'ni_value',
    },
    {
        label: $filter("translate")('NI Category Effective Date'),
        value: 'ni_start_date',
    },
    {
        label: $filter("translate")('Tronc Points'),
        value: 'tronc_value',
    },
    {
        label: $filter("translate")('Tronc Points Effective Date'),
        value: 'tronc_start_date',
    },
    {
        label: $filter("translate")('Marital Status'),
        value: 'personal_info_additional_info_marital_status',
    },
    {
        label: $filter("translate")('Student Loan'),
        value: 'payroll_taxes_additional_info_student_loan',
    },
    {
        label: $filter("translate")('Postgrad Loan'),
        value: 'payroll_taxes_additional_info_postgrad_loan',
    },
    {
        label: $filter("translate")('Pension Employee Contribution'),
        value: 'payroll_taxes_additional_info_pension_employee_contribution',
    },
    {
        label: $filter("translate")('Tax Code'),
        value: 'payroll_taxes_additional_info_tax_code',
    },
    {
        label: $filter("translate")('W1M1'),
        value: 'payroll_taxes_additional_info_w1m1',
    },
    {
        label: $filter("translate")('Pension Start Date'),
        value: 'payroll_taxes_additional_info_pension_start_date',
    },
    {
        label: $filter("translate")('Pension Scheme'),
        value: 'payroll_taxes_additional_info_pension_scheme',
    },
    {
        label: $filter("translate")('Pension Worker Group'),
        value: 'payroll_taxes_additional_info_pension_worker_group',
    },
    {
        label: $filter("translate")('Pension is AE Qualifying'),
        value: 'payroll_taxes_additional_info_pension_is_ae_qualifying',
    },
    {
        label: $filter("translate")('Auto Enrolled'),
        value: 'payroll_taxes_additional_info_auto_enrolled',
    },
    {
        label: $filter("translate")('Worker Status'),
        value: 'payroll_taxes_additional_info_worker_status',
    },
    {
        label: $filter("translate")('AE Opt Out'),
        value: 'payroll_taxes_additional_info_ae_opt_out',
    },
    {
        label: $filter("translate")('AE Opt Out Date'),
        value: 'payroll_taxes_additional_info_ae_opt_out_date',
    },
    {
        label: $filter("translate")('Starter Declaration'),
        value: 'employment_info_additional_info_starter_declaration',
    },
];

window.EMPLOYEE_AUDIT_WORK_LIMIT_FIELDS = [
    {
        label: $filter("translate")('Work limit start date'),
        value: 'work_limit_start_date',
    },
    {
        label: $filter("translate")('Work limit value'),
        value: 'work_limit_value',
    }
];

window.EMPLOYEE_AUDIT_CODE_TO_NAME_MAP = {
    ADD_LOCATION: $filter('translate')('Add Location'),
    ADD_PAY_TYPE: $filter('translate')('Add Pay Type'),
    UPDATE_PAY_TYPE: $filter('translate')('Update Pay Type'),
    DELETE_PAY_TYPE: $filter('translate')('Delete Pay Type'),
    ADD_PAY_RATE: $filter('translate')('Add Pay Rate'),
    UPDATE_PAY_RATE: $filter('translate')('Update Pay Rate'),
    DELETE_PAY_RATE: $filter('translate')('Delete Pay Rate'),
    ADD_TIPPED: $filter('translate')('Add Tipped'),
    UPDATE_TIPPED: $filter('translate')('Update Tipped'),
    DELETE_TIPPED: $filter('translate')('Delete Tipped'),
    ADD_BANK_ACCOUNT_DETAILS: $filter('translate')('Add Bank Account Details'),
    UPDATE_BANK_ACCOUNT_DETAILS: $filter('translate')('Update Bank Account Details'),
    DELETE_BANK_ACCOUNT_DETAILS: $filter('translate')('Delete Bank Account Details'),
    ADD_WORK_LIMIT: $filter('translate')('Add 48hr work limit'),
    UPDATE_WORK_LIMIT: $filter('translate')('Update 48hr work limit'),
    DELETE_WORK_LIMIT: $filter('translate')('Delete 48hr work limit'),
    ADD_EQUAL_OPPORTUNITY_INFORMATION: $filter('translate')('Add Equal opportunity Information'),
    UPDATE_EQUAL_OPPORTUNITY_INFORMATION: $filter('translate')('Update Equal Opportunity Information'),
    DELETE_EQUAL_OPPORTUNITY_INFORMATION: $filter('translate')('Delete Equal Opportunity Information'),
    ADD_NI: $filter('translate')('Add NI'),
    UPDATE_NI: $filter('translate')('Update NI'),
    DELETE_NI: $filter('translate')('Delete NI'),
    ADD_PENSION: $filter('translate')('Add Pension'),
    UPDATE_PENSION: $filter('translate')('Update Pension'),
    DELETE_PENSION: $filter('translate')('Delete Pension'),
    ADD_ADDITIONAL_COST: $filter('translate')('Add Additional Cost'),
    UPDATE_ADDITIONAL_COST: $filter('translate')('Update Additional Cost'),
    DELETE_ADDITIONAL_COST: $filter('translate')('Delete Additional Cost'),
    ADD_EMPLOYMENT_PERIOD: $filter('translate')('Add Hire/Termination Details'),
    UPDATE_EMPLOYMENT_PERIOD: $filter('translate')('Update Hire/Termination Details'),
    DELETE_EMPLOYMENT_PERIOD: $filter('translate')('Delete Hire/Termination Details'),
    ADD_USER_INFO: $filter('translate')('Add User Info'),
    UPDATE_USER_INFO: $filter('translate')('Update User Info'),
    DELETE_USER_INFO: $filter('translate')('Delete User Info'),
    ADD_ANNUAL_RATE: $filter('translate')('Add Annual Rate'),
    UPDATE_ANNUAL_RATE: $filter('translate')('Update Annual Rate'),
    DELETE_ANNUAL_RATE: $filter('translate')('Delete Annual Rate'),
    ADD_POSITION: $filter('translate')('Add Position'),
    DELETE_POSITION: $filter('translate')('Delete Position'),
    ADD_PAY_RATE_CODE: $filter('translate')('Add Pay Rate Code'),
    UPDATE_PAY_RATE_CODE: $filter('translate')('Update Pay Rate Code'),
    DELETE_PAY_RATE_CODE: $filter('translate')('Delete Pay Rate Code'),
    ADD_BADGE_ID: $filter('translate')('Add Time Card Number'),
    UPDATE_BADGE_ID: $filter('translate')('Update Time Card Number'),
    ADD_HOLIDAY_ADJUSTMENTS: $filter('translate')('Add Holiday Adjustments'),
    ADD_MAX_WEEKLY_HOURS: $filter('translate')('Add Max Weekly Hours'),
    UPDATE_MAX_WEEKLY_HOURS: $filter('translate')('Update Max Weekly Hours'),
    DELETE_MAX_WEEKLY_HOURS: $filter('translate')('Delete Max Weekly Hours'),
    ADD_SHIFTS_PER_WEEK: $filter('translate')('Add Shifts Per Week'),
    UPDATE_SHIFTS_PER_WEEK: $filter('translate')('Update Shifts Per Week'),
    DELETE_SHIFTS_PER_WEEK: $filter('translate')('Delete Shifts Per Week'),
    ADD_TRONC: $filter('translate')('Add Tronc'),
    UPDATE_TRONC: $filter('translate')('Update Tronc'),
    ADD_STATION_EXTRA_PAY: $filter('translate')('Add Station Extra Pay'),
    UPDATE_STATION_EXTRA_PAY: $filter('translate')('Update Station Extra Pay'),
    DELETE_STATION_EXTRA_PAY: $filter('translate')('Delete Station Extra Pay'),
    DELETE_TRONC: $filter('translate')('Delete Tronc'),
    ADD_PAYROLL_ID: $filter('translate')('Add Payroll Id'),
    UPDATE_PAYROLL_ID: $filter('translate')('Update Payroll Id'),
    UPDATE_HOLIDAY_ADJUSTMENTS: $filter('translate')('Update Holiday Adjustments'),
    ADD_LOCATION_PERIOD: $filter('translate')('Add Home/Shared Location'),
    UPDATE_LOCATION_PERIOD: $filter('translate')('Update Home/Shared Location'),
    DELETE_LOCATION_PERIOD: $filter('translate')('Delete Home/Shared Location'),
    UPDATE_POSITION: $filter('translate')('Update Position'),
    PERSONAL_INFO_ADDITIONAL_INFO: $filter("translate")('Personal Additional Info'),
    ADD_PERSONAL_INFO_ADDITIONAL_INFO: $filter("translate")('Add Personal Additional Info'),
    UPDATE_PERSONAL_INFO_ADDITIONAL_INFO: $filter("translate")('Update Personal Additional Info'),
    EMERGENCY_CONTACT: $filter("translate")('Emergency Contact'),
    ADD_EMERGENCY_CONTACT: $filter("translate")('Add Emergency Contact'),
    UPDATE_EMERGENCY_CONTACT: $filter("translate")('Update Emergency Contact'),
    EMPLOYMENT_INFO_ADDITIONAL_INFO: $filter("translate")('Employment Additional Info'),
    ADD_EMPLOYMENT_INFO_ADDITIONAL_INFO: $filter("translate")('Add Employment Additional Info'),
    UPDATE_EMPLOYMENT_INFO_ADDITIONAL_INFO: $filter("translate")('Update Employment Additional Info'),
    FEDERAL_WITHHOLDING_DETAILS: $filter("translate")('Federal Withholding Details'),
    ADD_FEDERAL_WITHHOLDING_DETAILS: $filter("translate")('Add Federal Withholding Details'),
    UPDATE_FEDERAL_WITHHOLDING_DETAILS: $filter("translate")('Update Federal Withholding Details'),
    STATE_WITHHOLDING_DETAILS: $filter("translate")('State Withholding Details'),
    ADD_STATE_WITHHOLDING_DETAILS: $filter("translate")('Add State Withholding Details'),
    UPDATE_STATE_WITHHOLDING_DETAILS: $filter("translate")('Update State Withholding Details'),
    CITY_WITHHOLDING_DETAILS: $filter("translate")('City Withholding Details'),
    ADD_CITY_WITHHOLDING_DETAILS: $filter("translate")('Add City Withholding Details'),
    UPDATE_CITY_WITHHOLDING_DETAILS: $filter("translate")('Update City Withholding Details'),
    REPORTS_TO: $filter('translate')('Hire/Termination Details'),
    ADD_REPORTS_TO: $filter('translate')('Add Hire/Termination Details'),
    UPDATE_REPORTS_TO: $filter('translate')('Update Hire/Termination Details'),
    KNOWN_AS: $filter('translate')('Hire/Termination Details'),
    ADD_KNOWN_AS: $filter('translate')('Add Hire/Termination Details'),
    UPDATE_KNOWN_AS: $filter('translate')('Update Hire/Termination Details'),
    ADDITIONAL_CONTACT_EMAIL: $filter('translate')('Hire/Termination Details'),
    ADD_ADDITIONAL_CONTACT_EMAIL: $filter('translate')('Add Hire/Termination Details'),
    UPDATE_ADDITIONAL_CONTACT_EMAIL: $filter('translate')('Update Hire/Termination Details'),
    BADGE_ID: $filter('translate')('Time Card Number'),
    SCHEDULABLE: $filter('translate')('Operational Information'),
    ADD_SCHEDULABLE: $filter('translate')('Add Operational Information'),
    UPDATE_SCHEDULABLE: $filter('translate')('Update Operational Information'),
    DELETE_SCHEDULABLE: $filter('translate')('Delete Operational Information'),
    LACTATION_BREAK_PERIOD: $filter('translate')('Operational Information'),
    ADD_LACTATION_BREAK_PERIOD: $filter('translate')('Add Operational Information'),
    UPDATE_LACTATION_BREAK_PERIOD: $filter('translate')('Update Operational Information'),
    DELETE_LACTATION_BREAK_PERIOD: $filter('translate')('Delete Operational Information'),
    MEAL_PLAN_PARTICIPANT: $filter('translate')('Meal Plan Participant'),
    ADD_MEAL_PLAN_PARTICIPANT: $filter('translate')('Add Meal Plan Participant'),
    UPDATE_MEAL_PLAN_PARTICIPANT: $filter('translate')('Update Meal Plan Participant'),
    POS_ID: $filter('translate')('POS ID'),
    ADD_POS_ID: $filter('translate')('Add POS ID'),
    UPDATE_POS_ID: $filter('translate')('Update POS ID'),
    USER_INFO: $filter('translate')('User Info'),
    ethnicity: $filter('translate')('Ethnicity'),
    specific_ethnicity: $filter('translate')('Specific Ethnicity'),
    other_ethnicity: $filter('translate')('Other Ethnictity'),
    disability_status: $filter('translate')('Disability Status'),
    gender_identity: $filter('translate')('Gender Identity'),
    other_gender_identity: $filter('translate')('Other Gender Identity'),
    sexual_orientation: $filter('translate')('Sexual Orientation'),
    other_sexual_orientation: $filter('translate')('Other Sexual Orientation'),
    religious_belief: $filter('translate')('Religious Belief'),
    other_religious_belief: $filter('translate')('Other Religious Belief'),
    flexible_working_arrangements: $filter('translate')('Flexible Working Arrangements'),
    other_flexible_working_arrangements: $filter('translate')('Other Flexible Working Arrangements'),
    caring_responsibilities: $filter('translate')('Caring Responsibilities'),
    type_of_caring_responsibilities: $filter('translate')('Type of Caring Responsibilities'),
    first_language: $filter('translate')('First Language'),
    pronoun: $filter('translate')('Pronoun'),
    reports_to: $filter("translate")('Reports To'),
    known_as: $filter("translate")('Known As'),
    schedulable: $filter("translate")('Include in Schedule'),
    secondary_email: $filter("translate")('Additional Contact Email'),
    is_meal_participant: $filter("translate")('Meal Plan Participant'),
    badge_id: $filter('translate')('Time Card Number'),
    middle_name: $filter('translate')('Middle Initial'),
    home_phone: $filter('translate')('Secondary Phone'),
    employee_pos_id: $filter('translate')('POS ID'),
    start_date: $filter('translate')('Start Date'),
    end_date: $filter('translate')('End Date'),
    description: $filter('translate')('Lactation Break Periods Description'),
    person_marital_status: $filter('translate')('Personal Marital Status'),
    national_origin: $filter('translate')('National Origin'),
    military_veteran_status: $filter('translate')('Military Veteran Status'),
    veteran_type: $filter('translate')('Veteran Type'),
    disabled_veteran: $filter('translate')('Disabled Veteran'),
    student_status: $filter('translate')('Student Status'),
    student_permit_exp_date: $filter('translate')('Student Permit Expiration Date'),
    schedule_visibility: $filter('translate')('Private Mode'),
    ADD_ANONYMOUS_FLAG: $filter('translate')('Add Operational Info'),
    UPDATE_ANONYMOUS_FLAG: $filter('translate')('Update Operational Info'),
    emergency_contact_first_name: $filter('translate')('First Name'),
    emergency_contact_last_name: $filter('translate')('Last Name'),
    emergency_contact_cell_phone_number: $filter('translate')('Primary Phone Number'),
    emergency_contact_home_phone_number: $filter('translate')('Secondary Phone Number'),
    emergency_contact_work_phone_number: $filter('translate')('Additional Phone Number'),
    company_service_date: $filter('translate')('Company Service Date'),
    orientation_date: $filter('translate')('Orientation Date'),
    follow_up_orientation_date: $filter('translate')('Follow-up Orientation Date'),
    federal_marital_status: $filter('translate')('Federal Marital Status'),
    federal_exempt_status: $filter('translate')('Federal Exempt Status'),
    do_not_calculate_federal_tax: $filter('translate')('Do Not Calculate Federal Tax'),
    do_not_calculate_state_tax: $filter('translate')('Do Not Calculate State Tax'),
    federal_tax_additional_amount: $filter('translate')('Federal Tax Deductions Amount'),
    federal_tax_deductions_amount: $filter('translate')('Federal Tax Filing Status'),
    federal_tax_dependents_amount: $filter('translate')('Federal Tax Other Income Amount'),
    federal_tax_filing_status: $filter('translate')('Federal Tax Additional Amount'),
    federal_tax_multiple_jobs: $filter('translate')('Federal Tax Dependents Amount'),
    federal_tax_other_income_amount: $filter('translate')('Federal Tax Multiple Jobs'),
    state_extra_tax: $filter('translate')('State Extra Tax'),
    number_of_exemptions: $filter('translate')('Number Of Exemptions'),
    flsa_overtime: $filter('translate')('Flsa Overtime'),
    business_unit: $filter('translate')('Business Unit'),
    home_department: $filter('translate')('Home Department'),
    benefits_eligibility_class: $filter('translate')('Benefits Eligibility Class'),
    federal_number_of_exceptions: $filter('translate')('Federal Number of Exceptions'),
    federal_extra_withholding: $filter('translate')('Federal Extra Withholding'),
    federal_multiple_jobs: $filter('translate')('Federal Multiple Jobs'),
    federal_qualifying_children_dollars: $filter('translate')('Federal Qualifying Children Dollars'),
    federal_other_dependent_dollars: $filter('translate')('Federal Other Dependent Dollars'),
    federal_total_dependent_dollars: $filter('translate')('Federal Total Dependent Dollars'),
    federal_deduction_dollars: $filter('translate')('Federal Deduction Dollars'),
    federal_other_income_dollars: $filter('translate')('Federal Other Income Dollars'),
    state_marital_status: $filter('translate')('State Marital Status'),
    state_exempt_status: $filter('translate')('State Exempt Status'),
    state_number_of_exceptions: $filter('translate')('State Number of Exceptions'),
    state_additional_withholding_amount: $filter('translate')('State Additional Withholding Amount'),
    city_marital_status: $filter('translate')('City Marital Status'),
    city_exempt_status: $filter('translate')('City Exempt Status'),
    city_number_of_exceptions: $filter('translate')('City Number of Exceptions'),
    city_additional_withholding_amount: $filter('translate')('City Additional Withholding Amount'),
    cross_location_edit_mode: $filter('translate')('Cross Location Edit Mode'),
    is_tipped: $filter('translate')('Is Tipped'),
    birth_date: $filter('translate')('Birth Date'),
    payroll_id: $filter('translate')('Payroll Id'),
    code: $filter('translate')('Code'),
    sort_code: $filter('translate')('Sort Code'),
    account_name: $filter('translate')('Account Name'),
    rate: $filter('translate')('Rate'),
    name: $filter('translate')('Name'),
    value: $filter('translate')('Value'),
    type: $filter('translate')('Type'),
    location: $filter('translate')('Location'),
    gender: $filter('translate')('Gender'),
    tips: $filter('translate')('Tips'),
    email: $filter('translate')('Email'),
    job_titles: $filter('translate')('Stations'),
    Employee: $filter('translate')('Employee'),
    change_date: $filter('translate')('Change Date'),
    affected_position: $filter('translate')('Affected Position'),
    change_type: $filter('translate')('Changed Type'),
    action: $filter('translate')('Action'),
    changed_field: $filter('translate')('Changed Field'),
    origional_value: $filter('translate')('Original Value'),
    updated_value: $filter('translate')('Updated Value'),
    changed_by: $filter('translate')('Changed By'),
    tronc: $filter('translate')('Tronc'),
    mode: $filter('translate')('Mode'),
    ADD_PAYROLL_TAXES_ADDITIONAL_INFO: $filter('translate')('Add Payroll & Taxes Additional Info'),
    UPDATE_PAYROLL_TAXES_ADDITIONAL_INFO: $filter('translate')('Update Payroll & Taxes Additional Info'),
    marital_status: $filter('translate')('Marital Status'),
    student_loan: $filter('translate')('Student Loan'),
    postgrad_loan: $filter('translate')('Postgrad Loan'),
    pension_employee_contribution: $filter('translate')('Pension Employee Contribution'),
    tax_code: $filter('translate')('Tax Code'),
    w1m1: $filter('translate')('W1M1'),
    pension_start_date: $filter('translate')('Pension Start Date'),
    pension_scheme: $filter('translate')('Pension Scheme'),
    pension_worker_group: $filter('translate')('Pension Worker Group'),
    pension_is_ae_qualifying: $filter('translate')('Pension is AE Qualifying'),
    auto_enrolled: $filter('translate')('Auto Enrolled'),
    worker_status: $filter('translate')('Worker Status'),
    ae_opt_out: $filter('translate')('AE Opt Out'),
    ae_opt_out_date: $filter('translate')('AE Opt Out Date'),
    starter_declaration: $filter('translate')('Starter Declaration'),
    deposit_amount_type: $filter('translate')('Deposit Amount Type'),
    amount: $filter('translate')('Amount'),
    order: $filter('translate')('Order'),
};

window.MIDDLE_NAME_MODES = {
    FIRST_INITIAL_ONLY: "FIRST_INITIAL_ONLY",
    FULL_MIDDLE_NAME: "FULL_MIDDLE_NAME",
};

window.EMPLOYEE_AUDIT_CODE = {
    ADD_USER_INFO: "ADD_USER_INFO",
    UPDATE_USER_INFO: "UPDATE_USER_INFO",
    DELETE_USER_INFO: "DELETE_USER_INFO",
};

window.EMPLOYEE_AUDIT_FIELDS_ENUM = {
    MIDDLE_NAME: "middle_name",
};

window.getEmployeeAuditLabel = (map, code, actionCode, settings) => {
    var label;
    if (actionCode) {
        if (actionCode === 'LACTATION_BREAK_PERIOD') {
            if (code === 'start_date') {
                label = $filter('translate')('Lactation Break Periods Start Date');
            }
            else if (code === 'end_date') {
                label = $filter('translate')('Lactation Break Periods End Date');
            }
        }
    }
    if (code) {

        if (code === EMPLOYEE_AUDIT_FIELDS_ENUM.MIDDLE_NAME) {
            if (settings?.middleNameSettings?.mode === MIDDLE_NAME_MODES.FIRST_INITIAL_ONLY) {
                label = $filter('translate')('Middle Initial');
            } else {
                label = $filter('translate')('Middle Name');
            }
        }

        if (code === 'ADD_TEAMHUB_PIN') {
            label = $filter('translate')('Add Operational Info');
        }
        else if (code === 'UPDATE_TEAMHUB_PIN') {
            label = $filter('translate')('Update Operational Info');
        }
    }
    return label || map[code] || code;
};

window.LOCATION_FILTER_TYPE = {
    ALL_LEVELS: 'ALL_LEVELS',
    CHILDREN_ONLY: 'CHILDREN_ONLY',
};